<template>
  <div :id="outerId" class="clearfix" :style="{ minHeight: minHeight + 'px', width: '100%' }">
    <div :id="chartId" :style="{ minHeight: minHeight + 'px', width: '100%' }">

    </div>
  </div>
</template>
<script>
  import ChartMixin from './mixins/chart'
  export default {
    name: 'SimpleStackedBar',
    mixins: [ChartMixin],
    props: {
      chartData: {
        /*
        * Data must be in the structure: {
        * categoryField: 'val',
        * valueA: 'val', (1 or more extra object prop forms stack)
        * }
        * where categoryField will equal this.props.categoryField --> x axis
        */
        type: Array,
        required: true
      },
      categoryField: {
        type: String,
        required: true
      },
      showLegend: {
        type: Boolean,
        default: true,
        required: false
      }
    },
    computed: {
      maxY () {
        let max = 0
        this.chartData.forEach(obj => {
          for (let prop in obj) {
            if (prop !== this.categoryField) {
              max = obj[prop] > max ? obj[prop] : max
            }
          }
        })
        return max
      }
    },
    methods: {
      init (data) {
        let graphs = []
        this.chartData.forEach(obj => {
          for (let prop in obj) {
            if (prop !== this.categoryField) {
              graphs.push({
                balloonText: '<b>[[title]]</b><br><span style="font-size:14px">[[category]]: <b>[[value]]</b></span>',
                fillAlphas: 0.8,
                labelText: '[[value]]',
                lineAlpha: 0.3,
                title: prop,
                type: 'column',
                color: '#000000',
                valueField: prop
              })
            }
          }
        })
        let legend = this.showLegend ? {
          horizontalGap: 10,
          maxColumns: 1,
          position: 'right',
          useGraphSettings: true,
          markerSize: 10
        } : null
        this.chart = window.AmCharts.makeChart(this.chartId, {
          type: 'serial',
          theme: 'light',
          legend: legend,
          dataProvider: this.chartData,
          categoryField: this.categoryField,
          valueAxes: [
            {
              stackType: 'regular',
              axisAlpha: 0.3,
              gridAlpha: 0
            }
          ],
          categoryAxis: {
            gridPosition: 'start',
            axisAlpha: 0,
            gridAlpha: 0,
            position: 'left'
          },
          graphs: graphs,
          export: {
            enabled: true
          }
        })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// SimpleStackedBar.vue?595ed382